import { render, staticRenderFns } from "./user-build-stat.vue?vue&type=template&id=2e3f4054&scoped=true&"
import script from "./user-build-stat.vue?vue&type=script&lang=js&"
export * from "./user-build-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f4054",
  null
  
)

export default component.exports